import { Grid, GridItem } from "@chakra-ui/react";
import { ScopeCard } from "../../components/SummaryCards";

const EngagementCards = ({currentYearData, previousYearData, isLoading}) => {
  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6} align="stretch">
      <GridItem h="100%" minH="250px">
        <ScopeCard
          title="Suppliers"
          currentYear={currentYearData?.supplierCountWithRequestedData}
          previousYear={previousYearData?.supplierCountWithRequestedData}
          currentLoading={isLoading}
          previousLoading={isLoading}
          theme="dark"
          unit=""
        />
      </GridItem>
      <GridItem h="100%" minH="250px">
        <ScopeCard
          title="Verified"
          currentYear={currentYearData?.verifiedSupplierCount}
          previousYear={previousYearData?.verifiedSupplierCount}
          currentLoading={isLoading}
          previousLoading={isLoading}
          theme="dark"
          unit=""
        />
      </GridItem>
      <GridItem h="100%" minH="250px">
        <ScopeCard
          title="Finalized"
          currentYear={currentYearData?.totalSuppliersWithAllFinalizedData}
          previousYear={previousYearData?.totalSuppliersWithAllFinalizedData}
          currentLoading={isLoading}
          previousLoading={isLoading}
          theme="dark"
          unit=""
        />
      </GridItem>
      <GridItem h="100%" minH="250px">
        <ScopeCard
          title="In Progress"
          currentYear={(currentYearData?.supplierCountWithRequestedData || 0) - (currentYearData?.totalSuppliersWithAllFinalizedData || 0)}
          previousYear={(previousYearData?.supplierCountWithRequestedData || 0) - (previousYearData?.totalSuppliersWithAllFinalizedData || 0)}
          currentLoading={isLoading}
          previousLoading={isLoading}
          theme="dark"
          unit=""
        />
      </GridItem>
    </Grid>
  )
}

export default EngagementCards;